const Footer = () => {
  return (
    <>
     <style>{`
     .footer{
      background-color: #1b3f6e
     }
     `};</style>
    <footer className="footer text-white text-center p-4 mt-10">
       {/* <footer className="bg-gray-800 text-white text-center p-4 mt-10"></footer> */}
      <p>© {new Date().getFullYear()} RoomsForYou. All Rights Reserved.</p>
    </footer>
    </>
  );
};

export default Footer;
